import axios from 'axios';
import {apiService} from "../../services/api.service";
import {convertToPageable, extractData, handleResponse} from "../../helpers/apiResponseHelper";
import { ChargingReportConfigurationForm } from './models';

async function findChargingReportConfigurations(pageRequest: any) {
    return axios.get(`${apiService.getApiUrl()}/charging/report-configurations/admin`, {
        params: pageRequest
    }).then(handleResponse).then(convertToPageable);
  }

async function postChargingReportConfiguration(request: ChargingReportConfigurationForm) {
    return axios.post(`${apiService.getApiUrl()}/charging/report-configurations/admin`,
        {
            ...request
        }).then(handleResponse).then(extractData);
}

async function putChargingReportConfiguration(id: number,request: ChargingReportConfigurationForm) {
    return axios.put(`${apiService.getApiUrl()}/charging/report-configurations/admin/${id}`,
        {
            ...request
        }).then(handleResponse).then(extractData);
}

async function deleteChargingReportConfiguration(id: number) {
    return axios.delete(`${apiService.getApiUrl()}/charging/report-configurations/admin/${id}`)
        .then(handleResponse);
}

export const ChargingReportConfigurationsService = {
    findChargingReportConfigurations,
    postChargingReportConfiguration,
    putChargingReportConfiguration,
    deleteChargingReportConfiguration
};